import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-points" }
const _hoisted_2 = { class: "user-points__item" }
const _hoisted_3 = { class: "user-points__item-count" }
const _hoisted_4 = {
  key: 0,
  class: "user-points__item"
}
const _hoisted_5 = { class: "user-points__item-count" }


export default /*@__PURE__*/_defineComponent({
  __name: 'UserPoints',
  props: {
    count1: {},
    count2: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "user-points__item-icon" }, [
        _createElementVNode("img", {
          src: "/images/user-points-icon-1.svg",
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.count1), 1)
    ]),
    (_ctx.count2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "user-points__item-icon" }, [
            _createElementVNode("img", {
              src: "/images/user-points-icon-2.svg",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.count2), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})